module.exports = __webpack_public_path__ + "static/media/minakuva4.740f6181.png";